<template slot-scope="{ nodeData }">
  <div class="org-chart-main">
    <div v-if="org_chart_permission === true">
        <div class="org-chart-main">
            <div id="chart-container"></div>
        </div>
    </div>
    <preLoader v-if="org_chart_permission === null"></preLoader>

    <notAllowed v-if="org_chart_permission === false"></notAllowed>
  </div>
</template>

<script>

var gThat = null;


export default {

  data() {
    return {
      ds : null,
      org_chart_permission : null
    };
  },
  methods: {

    getOrgChartData: function()
    {
      gThat.$Progress.start();

      axios.get("/api/getOrgChartData")
          .then(res => {
            if(res.status == 200)
            {
              this.ds = res.data.data;
              $(function() {


                var oc = $('#chart-container').orgchart({
                  'pan': false,
                  'data' : res.data.data,
                  'depth': 2,
                  'nodeContent': 'title',
                  'exportButton': true,
                  'exportFilename': "MyOrgChart",
                  'exportFileextension': "pdf",
                  'createNode': function($node, data) {
                    $node.on('click', function(event) {
                      if (!$(event.target).is('.edge, .toggleBtn')) {
                        var $this = $(this);
                        var $chart = $this.closest('.orgchart');
                        var newX = window.parseInt(($chart.outerWidth(true)/2) - ($this.offset().left - $chart.offset().left) - ($this.outerWidth(true)/2));
                        var newY = window.parseInt(($chart.outerHeight(true)/2) - ($this.offset().top - $chart.offset().top) - ($this.outerHeight(true)/2));
                        $chart.css('transform', 'matrix(1, 0, 0, 1, ' + newX + ', ' + newY + ')');
                      }
                    });
                  }
                });

                $('#btn_expand').on('click', function() {
                  var $temp = oc.$chart.find('.hidden').removeClass('hidden');
                  $temp[0].offsetWidth;
                  $temp.find('.slide-up').removeClass('slide-up');
                });

                $('#btn_collapse').on('click', function() {
                  oc.hideChildren(oc.$chart.find('.node:first'));
                });

              });
            }
            else
            {
              gThat.showAlertBox('error','Something went Wrong !');
            }

            gThat.$Progress.finish();
          })
          .catch(err => {
            console.log(err);
            gThat.$Progress.fail();
            gThat.showAlertBox('error','Something went Wrong !!');
          });
    },
  },
  mounted() {
    var base_url = window.location.origin;
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', base_url+'/assets/js/orgchart.js')
    document.head.appendChild(externalScript);

    let externalScript1 = document.createElement('script')
    externalScript1.setAttribute('src', base_url+'/assets/js/jspdf.min.js')
    document.head.appendChild(externalScript1);

    gThat = this;

    this.$Progress.start();

    this.can('org_chart')
        .then(result => {
          this.org_chart_permission = result.org_chart;

          if(this.org_chart_permission)
          {
            this.getOrgChartData();
          }
        }).catch(err => {
      console.log(err);
    });
  },
}
</script>

<style>
  
</style>